import { render, staticRenderFns } from "./ProfileUpdateForm.vue?vue&type=template&id=12675e5a&scoped=true&"
import script from "./ProfileUpdateForm.vue?vue&type=script&lang=js&"
export * from "./ProfileUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUpdateForm.vue?vue&type=style&index=0&id=12675e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12675e5a",
  null
  
)

export default component.exports